import { IMAGES } from './site';

// PROJECT / PORTFOLIO DATA — CMS PLACEHOLDER.
// The existing website does not publish a documented project gallery, so these
// are clearly-flagged placeholder case studies using stock photography. Replace
// entries with real project photography, locations, and details as they become
// available — the structure is CMS-ready. No client names, addresses, or
// unverifiable claims are included.
export const PROJECTS = [
  {
    slug: 'evening-kitchen-patio',
    title: 'The Evening Kitchen',
    category: 'Outdoor Kitchen & Patio',
    serviceSlug: 'outdoor-kitchens',
    image: IMAGES.kitchen,
    summary: 'A complete cooking and dining environment — built-in grill island, generous prep space, and a patio designed to gather the whole family around the table outdoors.',
    scope: ['Custom outdoor kitchen', 'Patio design & installation', 'Integrated lighting plan'],
    isPlaceholder: true,
  },
  {
    slug: 'pergola-garden-retreat',
    title: 'The Garden Retreat',
    category: 'Pergola & Seating',
    serviceSlug: 'pergolas',
    image: IMAGES.pergola,
    summary: 'A custom pergola defines this outdoor lounge, filtering afternoon sun while string lighting carries the space beautifully into the evening.',
    scope: ['Custom pergola', 'Seating area design', 'Accent lighting'],
    isPlaceholder: true,
  },
  {
    slug: 'fireside-living',
    title: 'Fireside Living',
    category: 'Fire Feature & Patio',
    serviceSlug: 'fire-features',
    image: IMAGES.firePit,
    summary: 'A stone fire feature anchors this patio, extending the outdoor season deep into Nebraska\'s crisp autumn months.',
    scope: ['Custom fire pit', 'Stone patio', 'Seat wall'],
    isPlaceholder: true,
  },
  {
    slug: 'covered-comfort',
    title: 'Covered Comfort',
    category: 'Patio Cover',
    serviceSlug: 'patio-covers',
    image: IMAGES.pergolaModern,
    summary: 'A covered patio turns fair-weather space into an everyday outdoor room — shade in summer, shelter when storms roll through.',
    scope: ['Custom patio cover', 'Ceiling fan & lighting', 'Furniture layout'],
    isPlaceholder: true,
  },
  {
    slug: 'the-sunroom',
    title: 'The Four-Season Room',
    category: 'Sunroom',
    serviceSlug: 'sunrooms',
    image: IMAGES.sunroom,
    summary: 'Floor-to-ceiling glass brings the backyard inside — a bright, comfortable room that works twelve months a year.',
    scope: ['Custom sunroom', 'Year-round insulation', 'Interior finishing'],
    isPlaceholder: true,
  },
  {
    slug: 'backyard-transformation',
    title: 'The Full Transformation',
    category: 'Complete Outdoor Living',
    serviceSlug: 'custom-outdoor-design',
    image: IMAGES.hero,
    summary: 'A master-planned backyard: cooking, dining, lounging, and fire — designed as one cohesive space and built by one team.',
    scope: ['Custom outdoor design', 'Outdoor kitchen', 'Patio & fire feature'],
    isPlaceholder: true,
  },
];

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug);
